import type { Glossary } from "@brookbush/types";

import GlossaryAlphabetMenu from "./GlossaryAlphabetMenu";
import GlossaryAlphabetSection from "./GlossaryAlphabetSection";
import Illustration from "~/components/Illustration";

interface GlossaryBodyProps {
	glossaries: { [key: string]: Glossary[] };
}

const GlossaryBody: React.FC<GlossaryBodyProps> = ({ glossaries }) => {
	return (
		<>
			<div className="relative col-span-full flex flex-col gap-6 lg:col-span-8">
				{!Object.keys(glossaries).length ? (
					<Illustration
						src="/illustrations/empty.svg"
						alt="No Glossary Terms found"
						title="No Glossary Terms Found"
						className="my-20"
					/>
				) : (
					Object.keys(glossaries).map((alphabet) => (
						<GlossaryAlphabetSection
							key={alphabet}
							alphabet={alphabet}
							glossaries={glossaries[alphabet]}
						/>
					))
				)}
			</div>

			<div className="col-span-full mt-4 flex flex-col gap-6 lg:col-span-3 lg:mt-[4.5rem]">
				<GlossaryAlphabetMenu />
			</div>
		</>
	);
};

export default GlossaryBody;
